import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FileDown, Plus } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { TabsList, Tabs, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Separator } from "@/components/ui/separator";
import DrinkIngredientsDraftListTable from "@/components/menu-management/manage-essential/essential-drinks/Ingredients/drink-Ingredients-draftList-table";
import DrinkIngredientsListTable from "@/components/menu-management/manage-essential/essential-drinks/Ingredients/drink-Ingredients-list-table";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFilter } from "@/hooks/useFilter";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";
import Paginat from "@/components/lib/paginat";

function IngredientsTabs() {
  const { id } = useParams();
  const { ingredients } = useSelector(
    (state) => state.essentialMenu.ingredients
  );

  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(ingredients, filters, {
    delay: 300,
  });

  const searchData = useSearch(
    filteredData,
    searchText,
    ["name", "description"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  return (
    <TabsContent value="ingredients">
      <div className="mt-5">
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
          <div className="w-[260px]">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2 left-2"
              />
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search"
                className="bg-cblack3 pl-8"
              />
            </div>
          </div>
          <div className="flex flex-col  gap-1.5 justify-end items-end">
            <div className="flex gap-3 justify-center items-center">
              <div className="relative">
                <Select
                  onValueChange={(value) =>
                    setFilters((prev) => ({
                      ...prev,
                      status: value === "0" ? "" : value,
                    }))
                  }
                >
                  <SelectTrigger className="w-[100px]">
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="0">All</SelectItem>
                    <SelectItem value="active">Active</SelectItem>
                    <SelectItem value="inactive">Inactive</SelectItem>
                    <SelectItem value="archive">Archived</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button
                className={"bg-cblack3 border border-gray-600 text-cwhite2"}
              >
                <FileDown size={18} /> Export
              </Button>
              <div className="flex gap-1 justify-center items-center">
                <h3 className="text-white">Show</h3>
                <Select
                  onValueChange={(value) => setPerPage(Number(value))}
                  value={perPage.toString()}
                >
                  <SelectTrigger className="w-[60px]">
                    <SelectValue placeholder="10" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectItem value="10">10</SelectItem>
                      <SelectItem value="20">20</SelectItem>
                      <SelectItem value="40">40</SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
              <Link
                to={`/backoffice/menu/essentail-menu/${id}/add-ingredients`}
              >
                <Button>
                  <Plus size={18} />
                  Add New Ingredient
                </Button>
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <Tabs
            className="bg-transparent relative"
            defaultValue="drink-list-category"
            valueKey="essential-ingredients"
          >
            <TabsList className="grid grid-cols-7 w-full">
              <Separator className="absolute top-8" />
              <TabsTrigger
                className="bg-transparent"
                value="drink-list-category"
              >
                Ingredients List
              </TabsTrigger>
              {/* <TabsTrigger value="draft">Draft</TabsTrigger> */}
            </TabsList>
            <DrinkIngredientsListTable data={paginatedData} />
            <DrinkIngredientsDraftListTable />
          </Tabs>
        </div>
        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default IngredientsTabs;
